<template>
	<custom-p-modal
		:value='isOpen'
		@input='onModalToggle'
		:contentStyle='{ overflow: "visible" }'
		title='Загрузка файлов на сервер'
	>

		<p-file-upload
			name='demo[]'
			:url='upload_photo_url'
			multiple
			accept='image/*'

		

			upload-label='Загрузить'
			cancel-label='Очистить'
			choose-label='Выбрать файлы'

			@select='onFileSelect'
			@remove='onFileClear'

			custom-upload
			@uploader='uploadFiles'

			ref='uploader'
		>
			<template #empty>
				Перетащите файлы для загрузки сюда
			</template>
		</p-file-upload>



		<p-message :closable='false'>
			<div>
				<div>Ширина и высота картинок должна быть равна (или больше):
				<div>
					3072 х 2304,
					2034 х 3072,
					3552 х 2000,
					2000 х 3552
				</div>
				</div>
			</div>
		</p-message>


	</custom-p-modal>
</template>

<script>
	const ROOT_API = process.env.VUE_APP_ROOT_API;
	const PHOTO_UPLOAD = ROOT_API + 'load_file/photo_upload.php';

	export default {
		name: 'PhotoUploadModal',

		model: {
			prop: 'isOpen'
		},

		props: [ 'isOpen', 'currentLpo' ],

		computed: {
			upload_photo_url() {
				return PHOTO_UPLOAD;
			}
		},

		methods: {
			onModalToggle(event) {
				this.$emit('input', event);
			},

			onFileSelect(event) {

				// console.log(event.files);

			},

			onFileClear(event) {
				// console.log('clear');
				// console.log(event);
			},

			uploadFiles(files) {

				// const uploader = this.$refs.uploader;

				// console.log(uploader.$children);

				// const url = URL.createObjectURL(files.files[0]);
				// const image = new Image;

				// image.src = url;

				


				// image.onload = function() {
				// 	console.log(image.width);
				// 	// URL.revokeObjectURL(image.src);
				// }

				// // console.log(files.files);
				// return;

				const form = new FormData();
				form.append('lpo_id', this.currentLpo.lpo_id);

				for (let file of files.files) {
					form.append('files[]', file);
				}

				fetch(PHOTO_UPLOAD, {
					credentials: 'include',
					method: 'post',
					body: form
				})
				.then(res => res.json())
				.then(res => {
					this.$emit('uploaded');
				});
			}
		}
	};
</script>

<style scoped>
</style>